import { EmptyCoroutineContext_instancegbhtm9svfl3r as EmptyCoroutineContext_instance } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from './Supervisor.mjs';
import { Dispatchers_getInstance20p7pyqnrepag as Dispatchers_getInstance } from './Dispatchers.mjs';
import {
  ContextScoper0znlsj7ufhq as ContextScope,
  ScopeCoroutine2c07fgm3ekmnx as ScopeCoroutine,
} from './internal/Scopes.mjs';
import {
  Key_instancebefxze3q9f64 as Key_instance,
  Job13y4jkazwjho0 as Job,
} from './Job.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { CancellationExceptionjngvjj221x3v as CancellationException } from './Exceptions.mjs';
import { startUndispatchedOrReturn1od7ryhr362dr as startUndispatchedOrReturn } from './intrinsics/Undispatched.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var GlobalScopeClass;
function GlobalScope() {
  if (GlobalScopeClass === VOID) {
    class $ {
      cw() {
        return EmptyCoroutineContext_instance;
      }
    }
    initMetadataForObject($, 'GlobalScope');
    GlobalScopeClass = $;
  }
  return GlobalScopeClass;
}
var GlobalScope_instance;
function GlobalScope_getInstance() {
  return GlobalScope_instance;
}
function MainScope() {
  return new (ContextScope())(SupervisorJob().qm(Dispatchers_getInstance().l13()));
}
function plus(_this__u8e3s4, context) {
  return new (ContextScope())(_this__u8e3s4.cw().qm(context));
}
function cancel(_this__u8e3s4, cause) {
  cause = cause === VOID ? null : cause;
  var tmp0_elvis_lhs = _this__u8e3s4.cw().bd(Key_instance);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = 'Scope cannot be cancelled because it does not have a job: ' + toString(_this__u8e3s4);
    throw IllegalStateException().o(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var job = tmp;
  job.mx(cause);
}
function CoroutineScope(context) {
  return new (ContextScope())(!(context.bd(Key_instance) == null) ? context : context.qm(Job()));
}
function cancel_0(_this__u8e3s4, message, cause) {
  cause = cause === VOID ? null : cause;
  return cancel(_this__u8e3s4, CancellationException(message, cause));
}
function *coroutineScope(block, $completion) {
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var coroutine = new (ScopeCoroutine())(uCont.pc(), uCont);
    return startUndispatchedOrReturn(coroutine, coroutine, block);
  };
}
//region block: init
GlobalScope_instance = new (GlobalScope())();
//endregion
//region block: exports
export {
  GlobalScope_instance as GlobalScope_instance3w3xrcgjszz2p,
  coroutineScope as coroutineScope39ukucf23mhsm,
  CoroutineScope as CoroutineScopelux7s7zphw7e,
  MainScope as MainScope1gi1r4abhrtmm,
  cancel as cancel36mj9lv3a0whl,
  cancel_0 as cancel2ztysw4v4hav6,
  plus as plusypd30qeai057,
};
//endregion

//# sourceMappingURL=CoroutineScope.mjs.map
